import { createLazyComponent, LazyAction, LazyImport, LazyModule } from 'owa-bundling';
import { runAfterSessionData } from 'owa-delayed-initialization';
import { CLPSubjectHeaderLabelProps } from './components/CLPSubjectHeaderLabel';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "CLP", webpackPrefetch: true */ './lazyIndex')
);

export const lazyLoadCLPUserLabels = new LazyAction(lazyModule, m => m.loadCLPUserLabels);
export const lazyShowJustificationModal = new LazyImport(lazyModule, m => m.showJustificationModal);
export const lazyLoadItemCLPInfo = new LazyAction(lazyModule, m => m.loadItemCLPInfo);
export const lazyUpdateItemCLPInfo = new LazyImport(lazyModule, m => m.updateItemCLPInfo);
export const lazyLogReadCLPLabel = new LazyImport(lazyModule, m => m.logReadCLPLabel);
export const CLPSubjectHeaderLabel = createLazyComponent(lazyModule, m => m.CLPSubjectHeaderLabel);

// The signature needs to be written into user options
// which has to happen after session data
runAfterSessionData(() => {
    lazyLoadCLPUserLabels.importAndExecute();
});

export { CLPSubjectHeaderLabelProps };
